const NotAuthenticated = () => {
    return (
        <div style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
            textAlign: "center",
            fontSize: "50px"
        }}>
            <h1>You are not authenticated ! </h1>
        </div>
    );
}

export default NotAuthenticated;
